import { MembershipValidityPeriod } from "../enums/ticketing";
import { getDatePlusNMonths, getDatePlusNYears, getNextOccurrenceWithThreeMonthGracePeriod } from "./dates";
export const isAddOnRate = (rate) => Boolean(rate.isAddOn);
export const getAddOnRates = (rates) => (rates ?? []).filter(isAddOnRate);
export const getTicketRates = (rates) => (rates ?? []).filter((rate) => !isAddOnRate(rate));
export const hasAddOnRates = (rates) => (rates ?? []).some(isAddOnRate);
export const getAvailableAddOnRates = (rates) => getAddOnRates(rates).filter((rate) => !rate.isHidden);
export const getAvailableAddOnCount = (rates) => getAvailableAddOnRates(rates).length;
export const findPerPurchaseViolation = (unitsByRateId, ratesById) => {
    for (const [rateId, units] of unitsByRateId) {
        const rate = ratesById.get(rateId);
        if (!rate) {
            continue;
        }
        const minimumToBuy = rate.minimumToBuy ?? 0;
        if (minimumToBuy > 0 && units < minimumToBuy) {
            return { code: "rate_below_minimum_per_purchase", rateId, units, minimumToBuy };
        }
        const maximumToBuy = rate.maximumToBuy ?? 0;
        if (maximumToBuy > 0 && units > maximumToBuy) {
            return { code: "rate_above_maximum_per_purchase", rateId, units, maximumToBuy };
        }
    }
    return null;
};
export const getMembershipExpirationDate = ({ membershipValidityPeriod, expirationDate, paymentDate, }) => {
    if (membershipValidityPeriod === MembershipValidityPeriod.OneYearAfterPayment) {
        return getDatePlusNYears(paymentDate || new Date(), 1);
    }
    else if (membershipValidityPeriod === MembershipValidityPeriod.OneMonthAfterPayment) {
        return getDatePlusNMonths(paymentDate || new Date(), 1);
    }
    else if (membershipValidityPeriod === MembershipValidityPeriod.AtDate && expirationDate) {
        return getNextOccurrenceWithThreeMonthGracePeriod(new Date(expirationDate));
    }
    return null;
};
